import { component } from "preact";
import { css } from "emotion";

const H3 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  maxWidth,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  children
}) => {
  const styleObj = {
    fontWeight: 600,
    fontSize: 20,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth ? maxWidth : "none",
    marginLeft: maxWidth ? "auto" : "none",
    marginRight: maxWidth ? "auto" : "none"
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    fontSize: 16,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };

  const style = css(styleObj);

  return <h3 className={style}>{children}</h3>;
};

export default H3;
